import { HoldingEventRes, HoldingEventType } from '@dealstack/shared/lib/generated';

export function getDateLabel(type: HoldingEventType, t) {
	switch (type) {
		case HoldingEventType.PLEDGING_OF_SHARES:
			return t('holdings.event.pledge_date');
		case HoldingEventType.ASSIGNMENT_OF_VOTING_RIGHTS:
			return t('holdings.event.assignment_date');
		case HoldingEventType.NOTE:
			return t('holdings.event.note_date');
		default:
			return t('holdings.event.issue_date');
	}
}

export const eventTypes = [
	HoldingEventType.ISSUANCE_OF_SHARE_CERTIFICATES,
	HoldingEventType.PLEDGING_OF_SHARES,
	HoldingEventType.ASSIGNMENT_OF_VOTING_RIGHTS,
	HoldingEventType.NOTE,
];

export const findEventByType = (events: HoldingEventRes[] | undefined, type: HoldingEventType) => {
	if (!events || !Array.isArray(events)) {
		return null;
	}
	return events.find((event) => event.type === type) || null;
};

export const hasEventType = (
	events: HoldingEventRes[] | undefined,
	type: HoldingEventType
): boolean => {
	if (!events || events.length === 0) {
		return false;
	}
	return events.some((event) => event.type === type);
};

/**
 * Resolves one edit-form field against the stored event.
 *
 * `undefined` is a field the form never rendered, so the stored value stands; `null` is the user
 * clearing it, and is the only value the API reads as "link this to nobody". Collapsing the two
 * put the stored value back, which is why a cleared id never actually cleared.
 */
export const resolveEditFieldValue = <T>(formValue: T | undefined, stored: T): T =>
	formValue === undefined ? stored : formValue;
